const middleware = {}

middleware['maintenance'] = require('../src/middleware/maintenance.ts')
middleware['maintenance'] = middleware['maintenance'].default || middleware['maintenance']

export default middleware
